$('.card-produto .btn-add-carrinho').mouseenter(function(){

    $(this).parents('.card-produto').addClass('detalhes-hover');

}).mouseleave(function(){

    $(this).parents('.card-produto').removeClass('detalhes-hover');

});